export const DISCIPLINE_STYLES = {
    eng: { icon: "code", color: "#4C9AF5", label: "Engineering", match: /^(eng|engineer|engineering|code|dev|programming)/ },
    des: { icon: "dice", color: "#C4D93C", label: "Design", match: /^(des|design|game ?design)/ },
    con: { icon: "pencil", color: "#D9C2FA", label: "Concept", match: /^(con|concept)/ },
    d3: { icon: "cube", color: "#B497F7", label: "3D", match: /^(d3|3d|model)/ },
    anim: { icon: "ball", color: "#9271EC", label: "Anim", match: /^(anim)/ },
    tech: { icon: "nodes", color: "#7356D6", label: "TechArt", match: /^(tech|techart|tech art|ta$)/ },
    aud: { icon: "wave", color: "#F28A4B", label: "Audio", match: /^(aud|audio|sound|sfx|music)/ },
    nar: { icon: "speech", color: "#D8C08A", label: "Narrative", match: /^(nar|narrative|story|writ)/ },
    qa: { icon: "bug", color: "#5FC46A", label: "QA", match: /^(qa|test|quality)/ },
};
const OUTSOURCED = /(_os$|\sos$|\(os\)$|outsourc)/i;
/** The starting style for a discipline, guessed from its key and label; null when nothing matches. */
export function guessDisciplineStyle(d) {
    const outsourced = OUTSOURCED.test(d.key) || OUTSOURCED.test(d.label.trim());
    const key = d.key.toLowerCase().replace(/_os$/, "");
    const label = d.label.toLowerCase().replace(/\s*(\(os\)|os)$/, "").trim();
    for (const s of Object.values(DISCIPLINE_STYLES))
        if (s.match.test(key) || s.match.test(label))
            return { ...s, outsourced };
    return null;
}
/** Fills in missing icons and colors from the starting styles. Returns a new config. */
export function styleDisciplines(config) {
    return {
        ...config,
        disciplines: config.disciplines.map(d => {
            const g = guessDisciplineStyle(d);
            if (!g)
                return d;
            const out = { ...d, icon: d.icon ?? g.icon, color: d.color ?? g.color };
            if (g.outsourced && d.outsourced === undefined)
                out.outsourced = true;
            return out;
        }),
    };
}
/** Adds a QA discipline when the project has none. Returns a new config. */
export function withQaDiscipline(config) {
    if (config.disciplines.some(d => guessDisciplineStyle(d)?.icon === "bug"))
        return config;
    const key = config.disciplines.some(d => d.key === "qa") ? "qa_test" : "qa";
    const s = DISCIPLINE_STYLES.qa;
    return { ...config, disciplines: [...config.disciplines, { key, label: s.label, hintKeywords: ["qa"], icon: s.icon, color: s.color }] };
}
//# sourceMappingURL=disciplines.js.map